export type RiskProfileType =
    | 'Conservative'
    | 'Moderate'
    | 'Aggressive'
    | 'Moderately Aggressive'
    | 'Moderately Conservative';
import type { MinMaxEquityItem } from '../pages/ClientJourneyCommon/RiskToleranceStep';

export const getRiskProfileMessage = (risk: RiskProfileType, t: any) => {
    const riskProfileMessages = new Map<RiskProfileType, string>([
        [t('CONSERVATIVE'), 'CLIENT_PROFILE_RISK_TOLERANCE_HELPER_CONSERVATIVE'],
        [t('MODERATE'), 'CLIENT_PROFILE_RISK_TOLERANCE_HELPER_MODERATE'],
        [t('AGGRESSIVE'), 'CLIENT_PROFILE_RISK_TOLERANCE_HELPER_AGGRESSIVE']
    ]);

    return riskProfileMessages.get(risk) || '';
};

export const getRiskRange = (
    profile: string,
    minMaxEquity: Record<string, MinMaxEquityItem> = {}
): [number, number] => {
    const normalizedProfile = profile.trim().toLowerCase();

    const matchedEntry = Object.entries(minMaxEquity).find(([key, value]) => {
        const normalizedKey = key.trim().toLowerCase();
        const normalizedRiskProfile = value?.riskProfile?.trim().toLowerCase();
        return normalizedKey === normalizedProfile || normalizedRiskProfile === normalizedProfile;
    });

    if (matchedEntry) {
        const [, matchedValue] = matchedEntry;
        // Assuming minEquity and maxEquity are in decimal form (e.g., 0.1 for 10%), convert them to percentage if they are not integers.
        // Remove the other case if BE confirms, minEquity and maxEquity will always be in uniform format - decimal or integers.
        if (Number.isInteger(matchedValue.minEquity) && Number.isInteger(matchedValue.maxEquity)) {
            return [matchedValue.minEquity, matchedValue.maxEquity];
        } else {
            return [matchedValue.minEquity * 100, matchedValue.maxEquity * 100];
        }
    }

    return [10, 90];
};

export const getRiskProfile = (profile: string): RiskProfileType => {
    switch (profile) {
        case 'Conservative':
            return 'Conservative';
        case 'Moderate':
            return 'Moderate';
        case 'Aggressive':
            return 'Aggressive';
        case 'ModeratelyAggressive':
            return 'Moderately Aggressive';
        case 'ConservativelyModerate':
            return 'Moderately Conservative';
        default:
            return 'Moderate';
    }
};
